import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export default function PasswordField({
  label,
  value,
  onChange,
  autoFocus = false,
  placeholder = "",
  className = "mt-1 w-full rounded-xl border border-[#e4ddd4] bg-white px-3 py-2 pr-28 text-sm",
  id,
}) {
  const [show, setShow] = useState(false);
  return (
    <label className="block text-sm">
      {label}
      <span className="relative mt-1 block">
        <input
          id={id}
          type={show ? "text" : "password"}
          value={value}
          onChange={onChange}
          autoFocus={autoFocus}
          placeholder={placeholder}
          autoComplete="current-password"
          className={className}
        />
        <button
          type="button"
          onClick={() => setShow((v) => !v)}
          className="absolute right-2 top-1/2 inline-flex -translate-y-1/2 items-center gap-1 rounded-full px-2 py-1 text-[11px] text-[#6d655e] hover:text-[#1c1917]"
        >
          {show ? <EyeOff size={14} /> : <Eye size={14} />}
          {show ? "Sembunyikan" : "Lihat password"}
        </button>
      </span>
    </label>
  );
}
